import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import AgreementsGrid from '../../../shared/CIPage/ConsentAndDeclarations/AgreementsGrid';
import { type Agreements, Container, Title } from '../../EventApplicationEntrypoint/ApplicantForm/shared';

export type ConsentsAndDeclarationsProps = {
    applicationAgreements: Agreements;
};

const ConsentsAndDeclarations = ({ applicationAgreements }: ConsentsAndDeclarationsProps) => {
    const { t } = useTranslation('eventApplicantForm');

    if (!applicationAgreements || applicationAgreements.length === 0) {
        return null;
    }

    return (
        <Container>
            <Title>{t('eventApplicantForm:consentsAndDeclarations.title')}</Title>
            <AgreementsGrid agreements={applicationAgreements} prefix="agreements" />
            <Divider />
        </Container>
    );
};

export default ConsentsAndDeclarations;
